export const buttonIcon = 'h-4 w-4 text-white mr-2';
export const buttonIconSaveFees =
  'h-4 w-4 text-white mr-2 bg-primary rounded-full';
export const hintStyle = 'block mt-1 text-sm font-body text-textMid';
export const label = 'font-semibold block text-base font-body text-textMid';
export const subLabel = 'font-medium block text-base font-body text-textMid';
